import { getDateTimeColumn, convertDate } from "./DateTimeValidation";

const emergencyWeekdaysDaytime = [
    {
        code: 'K960',
        price: 36.4,
        applicable: false,
        name:'Emergency Weekdays Daytime Travel Premium',
        reason: '',
        validate({ self, newApt, timePeriodAppointments }) {
            if (!newApt.performedTravel) {
                self.applicable = false;
                self.reason += 'Travel not performed.\n';
                return;
            }
            let occurences = 0;
            timePeriodAppointments.forEach(apt => {
                apt.codes.forEach(code => {
                    if (code == 'K960') occurences++;
                })
            })
            if (occurences >= 2) {
                self.applicable = false;
                self.reason += 'Maximum billing per cycle reached.'
            }
            self.applicable = true;
            self.reason = '';
        },
    },
    {
        code: 'K990',
        price: 20,
        name: 'First Person Seen Weekdays',
        applicable: false,
        reason: '',
        validate({ self, newApt, timePeriodAppointments }) {
  
            if (!newApt.firstPersonSeen) {
                self.applicable = false;
                self.reason = 'Patient was not first person seen.\n';
                return;
            }
            let occurences = 0;
            const codesThatCount = ['K990', 'K991'];
            timePeriodAppointments.forEach(apt => {
                apt.codes.forEach(code => {
                    if (codesThatCount.includes(code)) occurences++;
                })
            })
            if (occurences >= 10) {
                self.applicable = false;
                self.reason += 'Maximum billing per cycle reached.'
                return;
            }
            self.applicable = true;
            self.reason = '';
        }

    },
    {
        code: 'K991',
        price: 20,
        name: 'Additional Person Seen Weekdays',
        applicable: false,
        reason: '',
        validate({ self, newApt, timePeriodAppointments }) {
            if (newApt.firstPersonSeen) {
                self.applicable = false;
                self.reason = 'Patient was not additional person seen.\n';
                return;
            }
            let occurences = 0;
            const codesThatCount = ['K990', 'K991'];
            timePeriodAppointments.forEach(apt => {
                apt.codes.forEach(code => {
                    if (codesThatCount.includes(code)) occurences++;
                })
            })
            if (occurences >= 10) {
                self.applicable = false;
                self.reason += 'Maximum billing per cycle reached.'
                return;
            }
            self.applicable = true;
            self.reason = '';
        }

    },
];

const emergencyWeekdaysDaytimeSacrifice = [
    {
        code: 'K961',
        price: 36.4,
        applicable: false,
        reason: '',
        name: 'Travel Weekdays Sacrifice of Office Hours',
        validate({ self, newApt, timePeriodAppointments }) {
            if (!newApt.performedTravel) {
                self.applicable = false;
                self.reason += 'Travel not performed.\n';
                return;
            }
            let occurences = 0;
            timePeriodAppointments.forEach(apt => {
                apt.codes.forEach(code => {
                    if (code == 'K961') occurences++;
                })
            })
            if (occurences >= 2) {
                self.applicable = false;
                self.reason += 'Maximum billing per cycle reached.'
            }
            self.applicable = true;
            self.reason = '';
        },
    },
    {
        code: 'K992',
        price: 20,
        name: 'First Person Seen Weekdays Sacrifice of Hours',
        applicable: false,
        reason: '',
        validate({ self, newApt, timePeriodAppointments }) {
            if (!newApt.firstPersonSeen) {
                self.applicable = false;
                self.reason = 'Patient was not first person seen.\n';
                return;
            }
            let occurences = 0;
            const codesThatCount = ['K992', 'K993'];
            timePeriodAppointments.forEach(apt => {
                apt.codes.forEach(code => {
                    if (codesThatCount.includes(code)) occurences++;
                })
            })
            if (occurences >= 10) {
                self.applicable = false;
                self.reason += 'Maximum billing per cycle reached.'
                return;
            }
            self.applicable = true;
            self.reason = '';
        }

    },
    {
        code: 'K993',
        price: 40,
        name: 'Additional Person Seen Weekdays Sacrifice of Hours',
        applicable: false,
        reason: '',
        validate({ self, newApt, timePeriodAppointments }) {
            if (newApt.firstPersonSeen) {
                self.applicable = false;
                self.reason = 'Patient was not additional person seen.\n';
                return;
            }
            let occurences = 0;
            const codesThatCount = ['K992', 'K993'];
            timePeriodAppointments.forEach(apt => {
                apt.codes.forEach(code => {
                    if (codesThatCount.includes(code)) occurences++;
                })
            })
            if (occurences >= 10) {
                self.applicable = false;
                self.reason += 'Maximum billing per cycle reached.'
                return;
            }
            self.applicable = true;
            self.reason = '';
        }

    },
];

const emergencyWeekdaysEvening = [
    {
        code: 'K962',
        price: 36.4,
        applicable: false,
        name: 'Weekday Evening Travel',
        reason: '',
        validate({ self, newApt, timePeriodAppointments }) {
            if (!newApt.performedTravel) {
                self.applicable = false;
                self.reason += 'Travel not performed.\n';
                return;
            }
            let occurences = 0;
            timePeriodAppointments.forEach(apt => {
                apt.codes.forEach(code => {
                    if (code == 'K962') occurences++;
                })
            })
            if (occurences >= 2) {
                self.applicable = false;
                self.reason += 'Maximum billing per cycle reached.'
            }
            self.applicable = true;
            self.reason = '';
        },
    },
    {
        code: 'K994',
        price: 60,
        name: 'First Person Seen Weekday Evenings',
        applicable: false,
        reason: '',
        validate({ self, newApt, timePeriodAppointments }) {
            if (!newApt.firstPersonSeen) {
                self.applicable = false;
                self.reason = 'Patient was not first person seen.\n';
                return;
            }
            let occurences = 0;
            const codesThatCount = ['K994', 'K995'];
            timePeriodAppointments.forEach(apt => {
                apt.codes.forEach(code => {
                    if (codesThatCount.includes(code)) occurences++;
                })
            })
            if (occurences >= 10) {
                self.applicable = false;
                self.reason += 'Maximum billing per cycle reached.'
                return;
            }
            self.applicable = true;
            self.reason = '';
        }

    },
    {
        code: 'K995',
        price: 60,
        name: 'Additional Person Seen Weekdays',
        applicable: false,
        reason: '',
        validate({ self, newApt, timePeriodAppointments }) {
            if (newApt.firstPersonSeen) {
                self.applicable = false;
                self.reason = 'Patient was not additional person seen.\n';
                return;
            }
            let occurences = 0;
            const codesThatCount = ['K994', 'K995'];
            timePeriodAppointments.forEach(apt => {
                apt.codes.forEach(code => {
                    if (codesThatCount.includes(code)) occurences++;
                })
            })
            if (occurences >= 10) {
                self.applicable = false;
                self.reason += 'Maximum billing per cycle reached.'
                return;
            }
            self.applicable = true;
            self.reason = '';
        }

    },
];


const weekendOrHolidays = [
    {
        code: 'K963',
        price: 36.4,
        applicable: false,
        name: 'Weekend Daytime Travel',
        reason: '',
        validate({ self, newApt, timePeriodAppointments }) {
            if (!newApt.performedTravel) {
                self.applicable = false;
                self.reason += 'Travel not performed.\n';
                return;
            }
            let occurences = 0;
            timePeriodAppointments.forEach(apt => {
                apt.codes.forEach(code => {
                    if (code == 'K963') occurences++;
                })
            })
            if (occurences >= 6) {
                self.applicable = false;
                self.reason += 'Maximum billing per cycle reached.'
            }
            self.applicable = true;
            self.reason = '';
        },
    },
    {
        code: 'K998',
        price: 75,
        name: 'First Person Seen Weekends',
        applicable: false,
        reason: '',
        validate({ self, newApt, timePeriodAppointments }) {
            debugger
            const x = newApt
            if (!newApt.firstPersonSeen) {
                self.applicable = false;
                self.reason = 'Patient was not first person seen.\n';
                return;
            }
            let occurences = 0;
            const codesThatCount = ['K998', 'K999'];
            timePeriodAppointments.forEach(apt => {
                apt.codes.forEach(code => {
                    if (codesThatCount.includes(code)) occurences++;
                })
            })
            if (occurences >= 20) {
                self.applicable = false;
                self.reason += 'Maximum billing per cycle reached.'
                return;
            }
            self.applicable = true;
            self.reason = '';
        }

    },
    {
        code: 'K999',
        price: 75,
        name: 'Additional Person Seen Weekends',
        applicable: false,
        reason: '',
        validate({ self, newApt, timePeriodAppointments }) {
            if (newApt.firstPersonSeen) {
                self.applicable = false;
                self.reason = 'Patient was not additional person seen.\n';
                return;
            }
            let occurences = 0;
            const codesThatCount = ['K998', 'K999'];
            timePeriodAppointments.forEach(apt => {
                apt.codes.forEach(code => {
                    if (codesThatCount.includes(code)) occurences++;
                })
            })
            if (occurences >= 20) {
                self.applicable = false;
                self.reason += 'Maximum billing per cycle reached.'
                return;
            }
            self.applicable = true;
            self.reason = '';
        }

    },
];

const nights = [

    {
        code: 'K964',
        price: 36.4,
        applicable: false,
        name: 'Nightime Travel',
        reason: '',
        validate({ self, newApt, timePeriodAppointments }) {
            if (!newApt.performedTravel) {
                self.applicable = false;
                self.reason += 'Travel not performed.\n';
                return;
            }
            self.applicable = true;
            self.reason = '';
        },
    },
    {
        code: 'K996',
        price: 100,
        name: 'First Person Seen Nights',
        applicable: false,
        reason: '',
        validate({ self, newApt, timePeriodAppointments }) {
            if (!newApt.firstPersonSeen) {
                self.applicable = false;
                self.reason = 'Patient was not first person seen.\n';
                return;
            }
            self.applicable = true;
            self.reason = '';
        }

    },
    {
        code: 'K997',
        price: 100,
        name: 'Additional Person Seen Nights',
        applicable: false,
        reason: '',
        validate({ self, newApt, timePeriodAppointments }) {
            if (newApt.firstPersonSeen) {
                self.applicable = false;
                self.reason = 'Patient was not additional person seen.\n';
                return;
            }
            self.applicable = true;
            self.reason = '';
        }

    },


];


export function getEmergencyDepartmentColumn(newApt) {
    const dateObject = convertDate(newApt.date, newApt.time);
    const columnType = getDateTimeColumn(dateObject);

    // ['weekdaysDaytime','weekdaysEvening', 'nights', 'weekendOrHoliday']
    switch (columnType) {
        case 'weekdaysDaytime':
            if(newApt.sacrificeOfOfficeHours) return emergencyWeekdaysDaytimeSacrifice;
            else return emergencyWeekdaysDaytime;
        case 'weekdaysEvening':
            return emergencyWeekdaysEvening;
        case 'nights':
            return nights;
        case 'weekendOrHoliday':
            return weekendOrHolidays;
    }
}

// assume all are mutually exclusive...
